import React, { useState, useEffect } from "react";
import Currency from "react-currency-formatter";
import attachDocument from '../../../../layout/Logistic/Attachment'
import Loading from '~/components/layout/Loading';
import moment from "moment";
import {
  Container,
  Title,
  Left,
  Right,
  Details,
  IconInformation,
  Middle,
  ItemDetails,
} from "./styles";
import information from "~/assets/images/information.svg";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as InvoiceActions } from "~/store/ducks/invoice";

function DesktopCashPayment({ data, handleShowButton }) {
  const [fileAttached, setFileAttached] = useState(false)
  const [isLoading, setIsLoading] = useState(false)


  useEffect(()=>{
    handleShowButton({id: data.id, status:fileAttached })
  },[fileAttached])

  const formattedValue = data.netValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
  
  return (
    <Container
      className="mb-3"
      style={{ cursor:  "pointer" }}
    >
    {isLoading ? (
        <Loading margin={"0px 0px 0px 48%"} />
     ) : (  
       <>
        <Left>
         <ItemDetails>Pedido </ItemDetails>
         <Title>{data.number}</Title>
        </Left>
        <Middle>
          <ItemDetails>Vencimento: </ItemDetails>
          <Title>{moment(data.expirationDate).format("DD/MM/YYYY")}</Title>
        </Middle>
        <Right>
          <Title>
            {formattedValue}
          </Title>
            <Details
              color={fileAttached}
              onClick={() => {
                attachDocument(data.id, setFileAttached, setIsLoading);
              }}
            >
              Anexar comprovante
              <img src={information} style={IconInformation} />
          </Details>
              
        </Right>
        </>
         
      )}
    </Container>
  );
}

const mapStateToProps = (state) => ({
  modalInformation: state.invoiceReducer.modalInformation,
  access_token: state.loginReducer.access_token,
  login_email: state.loginReducer.login_email,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(InvoiceActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DesktopCashPayment);